import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import {
  DistrictDTO,
  DistrictSimpleDto,
} from 'src/app/common/dtos/district.dto';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { DistrictListService } from 'src/app/private/shared/services/district-list/district-list-service';
import { LmsCourseListService } from 'src/app/private/shared/services/lms-courses/lms-course-list.service';
import {
  GetAllLmsCoursesAPIResponse,
  LmsCourseAPIResponse,
} from 'src/app/private/shared/types/responses/lms-course.responses';

@Component({
  selector: 'app-lms-courses',
  standalone: false,

  templateUrl: './lms-courses.component.html',
  styleUrl: './lms-courses.component.scss',
})
export class LmsCoursesPageComponent {
  isLoading = true;

  isCreating = false;

  districtList: DistrictSimpleDto[] = [];

  district: DistrictDTO;

  districtCode: string;

  user: User | null;

  pagination: PaginationDTO;

  currentPage = 1;

  // submissionModalId: number;

  // submissionModalTitle: string;

  courses: LmsCourseAPIResponse[];

  searchTerm: string;

  searchTimeout: ReturnType<typeof setTimeout>;

  selectedCourseId: number | null;

  showingCreateModal = false;

  showingRegistrationModal = false;

  showingEditModal = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private districtListService: DistrictListService,
    private store: Store,
    private lmsCourseListService: LmsCourseListService
  ) {
    this.districtCode = this.route.snapshot.paramMap.get(
      'districtCode'
    ) as string;
    this.user = this.store.selectSnapshot(UserState.getUser);
    this.districtListService
      .fetchDistrictsSimple({ per_page: 1000 })
      .subscribe((districts) => {
        if (districts) {
          this.districtList = districts;
          const district = districts.find(
            (searchDistrict) =>
              searchDistrict.districtCode === this.districtCode
          ) as DistrictDTO;
          if (district) {
            this.district = district;
          } else {
            this.district = districts.find(
              (searchDistrict) => searchDistrict.id === 2
            ) as DistrictDTO;
            this.districtCode = this.district.districtCode;
          }
          this.loadLmsCourses();
        }
      });
  }

  loadLmsCourses(): void {
    this.lmsCourseListService
      .getCourses(this.district.id, 10, this.currentPage)
      .subscribe((resp: GetAllLmsCoursesAPIResponse) => {
        if (resp.items) {
          this.courses = resp.items;
          this.pagination = resp._meta;
          this.isLoading = false;
        }
      });
  }

  searchTermChanged(event: Event) {
    this.searchTerm = (<HTMLInputElement>event.target).value;
    this.searchDebounce();
  }

  searchDebounce() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.currentPage = 1;
      this.getLmsCoursesWithSearchTerm();
    }, 300);
  }

  getLmsCoursesWithSearchTerm() {
    this.lmsCourseListService
      .getCourses(
        this.district.id,
        10,
        this.currentPage,
        undefined,
        this.searchTerm
      )
      .subscribe((resp: GetAllLmsCoursesAPIResponse) => {
        if (resp.items) {
          this.courses = resp.items;
          this.pagination = resp._meta;
          this.isLoading = false;
        }
      });
  }

  pageChange(newPage: number) {
    this.currentPage = newPage;
    this.loadLmsCourses();
  }

  showRegistrationsModal(courseId: number) {
    this.selectedCourseId = courseId;
    this.showingRegistrationModal = true;
  }

  showEditModal(courseId: number) {
    this.selectedCourseId = courseId;
    this.showingEditModal = true;
  }

  hideCreateModal() {
    this.showingCreateModal = false;
  }

  hideRegistrationModal() {
    this.selectedCourseId = null;
    this.showingRegistrationModal = false;
  }

  hideEditModal() {
    this.selectedCourseId = null;
    this.showingEditModal = false;
    this.loadLmsCourses();
  }
}
